import { useState } from 'react'
import { Button, Choice } from '../../design'
import { deviceStorage } from '../../design/typeScale'
import { desktopPermission, requestDesktopPermission, type DesktopPermission } from './desktopNotification'
import { NOTIFICATION_COPY } from './notificationCopy'
import { PushSetting } from './PushSetting'
import { primeAlertTone, readSoundEnabled, storeSoundEnabled } from './sound'

const SOUND_CHOICE = 'sound'

const SoundSetting = () => {
  const [enabled, setEnabled] = useState(() => readSoundEnabled(deviceStorage()))

  const toggle = () => {
    const next = !enabled
    storeSoundEnabled(deviceStorage(), next)
    setEnabled(next)
    if (next) primeAlertTone()
  }

  return (
    <div className="notification-setting">
      <Choice
        type="checkbox"
        name={SOUND_CHOICE}
        value={SOUND_CHOICE}
        checked={enabled}
        onChange={toggle}
        label={NOTIFICATION_COPY.sound}
        description={NOTIFICATION_COPY.soundHint}
      />
    </div>
  )
}

const DESKTOP_STATES: Record<Exclude<DesktopPermission, 'default'>, string> = {
  granted: NOTIFICATION_COPY.desktopOn,
  denied: NOTIFICATION_COPY.desktopDenied,
  unsupported: NOTIFICATION_COPY.desktopUnsupported,
}

const DesktopSetting = () => {
  const [permission, setPermission] = useState<DesktopPermission>(desktopPermission)
  const [asking, setAsking] = useState(false)

  const ask = async () => {
    setAsking(true)
    setPermission(await requestDesktopPermission())
    setAsking(false)
  }

  return (
    <div className="notification-setting">
      <h3>{NOTIFICATION_COPY.desktopTitle}</h3>
      <p className="settings-hint measure">{NOTIFICATION_COPY.desktopHint}</p>
      {permission === 'default' ? (
        <Button variant="primary" pending={asking} onClick={() => void ask()}>
          {NOTIFICATION_COPY.desktopEnable}
        </Button>
      ) : (
        <p className="notification-state">{DESKTOP_STATES[permission]}</p>
      )}
    </div>
  )
}

export const NotificationSettings = () => (
  <section className="card settings-card" aria-labelledby="notification-heading">
    <h2 id="notification-heading">{NOTIFICATION_COPY.title}</h2>
    <p className="settings-hint measure">{NOTIFICATION_COPY.deviceOnly}</p>
    <SoundSetting />
    <DesktopSetting />
    <PushSetting />
  </section>
)
